import { useEffect, useState } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useGetCountryCurrency = () => {
    const [currencyList, setCurrencyList] = useState([]);
    const [countryList , setCountryList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await apiRequest(`${API_ENDPOINTS.AUTH.GET_COUNTRY_CURRENCY}`, 'GET');
                setCurrencyList(result.currency_list);
                setCountryList(result.country_list);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, []);

    return { currencyList, countryList };
};
